import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const ganttChartV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Gantt Chart element to v2 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'ganttChart'>): void => {
    const ganttChartProps = props;

    if (ganttChartProps?.style?.title?.text && !ganttChartProps?.content?.title?.iconColor) {
      const currentColor = ganttChartProps.style.title.text.color1;
      ganttChartProps.content = {
        ...ganttChartProps.content,
        title: {
          ...ganttChartProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
